import {
  CARAT_DATA,
  GOLD_DATA,
  GRAM_WISE_CARAT_RATE,
  SILVER_DATA,
} from './types';

export const capitalized = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1);

export enum SIGN {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  ZERO = 'zero',
}
export const checkNumberSign = (value: number): string => {
  if (value > 0) return SIGN.POSITIVE;
  if (value < 0) return SIGN.NEGATIVE;
  return SIGN.ZERO;
};

export const getGramWiseGoldData = (
  data: GOLD_DATA
): GRAM_WISE_CARAT_RATE[] => {
  return [
    {
      carat: '24 carat',
      rate: data.carat24.ratePerGram,
      change: data.carat24.change,
    },
    {
      carat: '22 carat',
      rate: data.carat22.ratePerGram,
      change: data.carat22.change,
    },
  ];
};

export const getGramWiseSilverData = (data: SILVER_DATA): CARAT_DATA[] => {
  return [
    {
      ratePerGram: data.ratePerGram,
      change: data.change,
    },
  ];
};

export const getMetalData = async (URLArrays: Array<string>) => {
  const array = await Promise.all(URLArrays.map((url) => fetch(url)));
  return await Promise.all(array.map((res) => res.json()));
};
